var minMaxValidationModule = require('./angular-min-max-validation');
module.exports = minMaxValidationModule.name;
